<script>
export default {
  props: {
    accessKey: {
      type: String,
      required: true,
    },
    restAccessId: {
      type: String,
      required: true,
    },
    jwtToken: {
      type: String,
      required: true,
    },
    deviceOS: {
      type: String,
    },
    redirect: String,
  },
  async mounted() {
    try {
      await this.$store.dispatch('session/setStorageCredentials', {
        access_key: this.accessKey,
        rest_acccess: this.restAccessId,
        token: this.jwtToken,
      });
      this.$store.dispatch('globalState/setLocalItem', {
        key: 'deviceOS',
        value: this.deviceOS,
      });

      if (this.redirect != null && this.redirect.trim() !== '') {
        this.$router.push(this.redirect);
      }
    } catch (ex) {
      console.error('error retrieving user info from injected credentials', ex);
      this.$router.push('/login');
    }
  },
  render(h) {
    return h('div');
  },
};
</script>
